<template>
    <div id="cliente-cadastro">
        <my-tour v-if="simuladorStatus != 2" :steps="steps" name="steps-cadastro-cliente"></my-tour>
        <section id="content">
            <!--start container-->
            <div class="container">
                <TituloPagina titulo="Cadastro de cliente" />
                <div class="row">
                    <div class="col s12 m12 l12">
                        <div id="customer-registration" class="col s12 m6 l2 " v-if="simuladorStatus != 2">
                            <div class="center" v-if="simuladorStatus == 1">
                                <button class="btn" @click="marcarProduto(0)" style="width: 85%" :class="produtos.includes(0) ? 'btn-default' : 'text-default white'">
                                    SIMULAR
                                </button>
                            </div>
                            <br />
                            <div class="scroll">



                                <div v-for="(item, index) in produtosItens" :key="index">
                                    <!-- <div class="card product pink darken-3 z-depth-3">-->
                                    <div class="card product gradient-shadow bg-primary z-depth-3">
                                        <div class="padding-3 center-align">
                                            <i class="material-icons white-text card-icon">{{ item.produto_icone}}</i>
                                            <button
                                                class="btn-flat waves-effect icon-absolute btn-floating btn-transparent right product-detail"
                                                v-tooltip.top="'Detalhes'" @click="abreModalDetalhe(item)">
                                                <i class="material-icons product-detail-icon">info_outline</i>
                                            </button>
                                            <h6 class="center-align white-text uppercase">{{ item.produto_nome }}</h6>
                                            <!--  <p style="font-size: 14px">{{ item.produto_descricao ? item.produto_descricao : 'Sem descrição' }}</p>-->
                                            <div class="border-non mt-5 center-align">
                                                <button class="btn white waves-effect waves-light btn-small text-default"
                                                    :class="checkProduto(item.produto_id) ? '' : 'active'"
                                                    @click="marcarProduto(item.produto_id)">
                                                    {{ checkProduto(item.produto_id) ? 'Selecionar' : 'Selecionado' }}
                                                </button>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div style="position:relative">
                            <span class="fktour"
                                style="position:absolute;margin-left: -60px;margin-top: 20px; opacity:0">aaaaaa</span>
                            <div class="col s12" :class="simuladorStatus == 2 ? '' : 'm6 l10'">

                                <div class="container-xml">
                                    <div class="status" :style="{color: status_upload_xml.color}" v-if="status_upload_xml.display">
                                        <i class="material-icons">{{status_upload_xml.icon}}</i>
                                        {{status_upload_xml.text}} <template v-if="status_upload_xml.progress !== null">{{ status_upload_xml.progress || 0 }}%</template>
                                    </div>
                                    <label id="label" class="label_xml" for="upload">
                                        <div>Enviar arquivo...</div>
                                        <a id="upload" role="button" class="btn btn-flat btn-default upload" @click="$refs.input_xml.click()">
                                            Importar xml
                                        </a>
                                    </label>
                                    <input class="file" ref="input_xml" type="file" name="xml" accept=".xml" @change="submitFile($event)"/>
                                </div>

                                <form class="card-panel" v-on:submit.prevent="validateBeforeSubmit">
                                    <div class="row" v-if="checkSeguroAuto()">
                                        <div class="col m12">
                                            <h4 class="header2">Informações adicionais</h4>
                                            <div class="row">
                                                <div class="input-field col m6 s12">
                                                    <input id="auto_marca" type="text" v-model="auto.marca">
                                                    <label for="auto_marca" :class="checkValue(auto.marca)">Marca
                                                        do veículo*</label>
                                                </div>
                                                <div class="input-field col m6 s12">
                                                    <input id="auto_modelo" type="text" v-model="auto.modelo">
                                                    <label for="auto_modelo"
                                                        :class="checkValue(auto.modelo)">Modelo do veículo*</label>
                                                </div>
                                            </div>
                                            <div class="row">
                                                <div class="input-field col m3 s12">
                                                    <masked-input type="text" id="auto_ano_fab"
                                                        v-model="auto.ano_fabricacao" mask="1111" />
                                                    <label for="auto_ano_fab" :class="checkValue(auto.ano_fabricacao)">Ano
                                                        fabricação*</label>
                                                </div>
                                                <div class="input-field col m3 s12">
                                                    <masked-input type="text" id="auto_ano_mod"
                                                        v-model="auto.ano_modelo" mask="1111" />
                                                    <label for="auto_ano_mod" :class="checkValue(auto.ano_modelo)">Ano
                                                        modelo*</label>
                                                </div>
                                                <div class="col m3 s12">
                                                    <label for="auto_renovacao">É renovação?*</label>
                                                    <select class="browser-default" v-model="auto.renovacao"
                                                        id="auto_renovacao">
                                                        <option value="1">Sim</option>
                                                        <option value="0">Não</option>
                                                    </select>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <formulario-pessoa @newdata="handleDataPessoa($event)"></formulario-pessoa>
                                    <formulario-pedido @newdata="handleDataPedido($event)"></formulario-pedido>
                                    <formulario-beneficiario @newdata="handleDataBeneficiario($event)"></formulario-beneficiario>
                                    <formulario-endereco id="endereco_pessoal" @newdata="handleDataEndereco($event)">
                                    </formulario-endereco>
                                    <formulario-endereco :title="'Endereço comercial'" id="endereco_comercial"
                                        @newdata="handleDataEnderecoComercial($event)"></formulario-endereco>
                                    <!--<div class="row" v-if="checaCargoUsuario([cargoDono, cargoGerente, cargoEspecialista])">
                                            <div class="col m3 s12">
                                                <label for="campanha_id">Campanha</label>
                                                <select class="browser-default" v-model="campanha_id" id="campanha_id">
                                                    <option value="1">Campanha 1</option>
                                                    <option value="2">Campanha 2</option>
                                                </select>
                                            </div>
                                        </div>-->
                                    <div class="row">
                                        <div class="input-field col s12 pb-1">
                                            <button id="save-customer" class="btn btn-default waves-effect waves-light right"
                                                type="submit" name="action">
                                                Salvar
                                                <!-- <i class="material-icons right">send</i> -->
                                            </button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!--end container-->
        </section>


        <!-- Modal Detalhe produtos -->
        <div id="modalDetalheProdutos" class="modal modal-fixed-footer">
            <div class="modal-content pt-0 pl-0 pr-0">
                <div class="modal-header">
                    <div class="row pt-2">
                        <div class="col m12">
                            <h4 class="ml-2 header2">Informações do produto</h4>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col m6">
                        <label class="Search__title">Nome:</label>
                        {{ currentProduto.produto_nome }}
                    </div>
                </div>
                <div class="row">
                    <div class="col m12">
                        <label class="Search__title">Descrição:</label>
                        {{ currentProduto.produto_descricao }}
                    </div>
                </div>
                <div class="row">
                    <div class="col m12">
                        <label class="Search__title">Diferenciais:</label>
                        {{ currentProduto.produto_diferenciais }}
                    </div>
                </div>
            </div>
            <div class="modal-footer grey lighten-3">
                <button class="modal-action modal-close btn waves-effect waves-light grey darken-1">Fechar</button>
            </div>
        </div>
    </div>
</template>

<script>
    import FormularioPessoa from '@/components/common/FormularioPessoa';
    import FormularioBeneficiario from '@/components/common/FormularioBeneficiario';
    import FormularioEndereco from '@/components/common/FormularioEndereco';
    import FormularioPedido from '@/components/common/FormularioPedido';
    import TituloPagina from '@/components/common/TituloPagina';
    import { get, post, api } from '@/helpers/api';
    import moment from "moment";
    import MaskedInput from 'vue-masked-input';
    import { DONO, GERENTE, CORRETOR, ESPECIALISTA, LIDER, MASTER, PARCEIRO } from '@/constants/funcionarioCargo.js';
    import Auth from '@/store/auth';
    import MyTour from '@/components/common/MyTour.vue';
    import Message from '@/helpers/message';
    import TourHelper from '@/helpers/tour';
    import axios from 'axios'
    import { PRODUTO_NENHUM_ID } from '@/constants/produtoNenhum';

    export default {
        components: {
            FormularioPessoa,
            FormularioBeneficiario,
            FormularioEndereco,
            FormularioPedido,
            MaskedInput,
            MyTour,
            TituloPagina
        },
        data: () => ({
            simuladorStatus: 2,
            campanha_id: 1,
            file: '',
            status_upload_xml: {
                display: false,
                icon: null,
                color: null,
                text: null,
                progress: null,
            },
            pessoa: {
                pessoa_nome: '',
                pessoa_cpf: '',
                pessoa_email: '',
                pessoa_sexo: '',
                pessoa_telefone: '',
                pessoa_celular: '',
                pessoa_data_nascimento: '',
                pessoa_profissao: '',
                pessoa_estado_civil: '',
                pessoa_filhos: '',
                pessoa_observacao: '',
            },
            beneficiario: {
                beneficiario_nome: '',
                beneficiario_data_nascimento: '',
            },
            endereco: {
                endereco_cep: '',
                endereco_estado: '',
                endereco_cidade: '',
                endereco_bairro: '',
                endereco_logradouro: '',
                endereco_numero: '',
                endereco_complemento: '',
            },
            enderecoComercial: {
                endereco_cep: '',
                endereco_estado: '',
                endereco_cidade: '',
                endereco_bairro: '',
                endereco_logradouro: '',
                endereco_numero: '',
                endereco_complemento: '',
            },
            empresa_id: 1,
            produtos: [],
            produtosItens: [],
            currentProduto: {
                produto_nome: '',
                produto_descricao: '',
                produto_diferenciais: '',
                produto_icone: ''
            },
            auto: {
                auto_marca: '',
                auto_modelo: '',
                auto_ano_fab: '',
                auto_ano_mod: '',
                auto_renovacao: 'Sim'
            },
            pedido: {
                plataforma_origem: 1,
                pedido_estagio_id: '',
            },
            cargoDono: null,
            cargoGerente: null,
            cargoCorretor: null,
            cargoEspecialista: null,
            cargoParceiro: null,
            usuarioLogadoCargo: null,
            steps: [
                {
                    parent: '.card.product:eq(0) .product-detail',
                    target: '.fktour',
                    content: 'Aqui fica as informações do produto para consulta!',
                    params: {
                        cargos: [DONO, PARCEIRO, GERENTE, CORRETOR, ESPECIALISTA, LIDER],
                        placement: 'right',
                        bgTransparent: true,
                        bgClass: 'color-default',
                        menu: false
                    }
                },
                {
                    parent: '.formulario-pessoa',
                    target: '.formulario-pessoa',
                    content: 'Preencher os campos com os dados pessoais e informações adicionais quando necessário!',
                    params: {
                        cargos: [DONO, PARCEIRO, GERENTE, CORRETOR, ESPECIALISTA, LIDER],
                        placement: 'bottom',
                        menu: false
                    }
                },
                {
                    parent: '#save-customer',
                    target: '#save-customer',
                    content: 'E clicar em salvar!',
                    params: {
                        cargos: [DONO, PARCEIRO, GERENTE, CORRETOR, ESPECIALISTA, LIDER],
                        placement: 'right',
                        menu: false
                    }
                },
                {
                    parent: '#left-sidebar-nav',
                    target: '#ajuda',
                    content: 'Caso queira rever este tutorial, você pode clicar clicar em <b>Ajuda</b>, lá terá um botão para reiniciar o tour e a descrição dos itens que são abordados nele! Até breve!',
                    params: {
                        cargos: [CORRETOR, ESPECIALISTA, LIDER, PARCEIRO],
                        placement: 'left',
                        menu: true,
                        route: '/',
                        subMenu: false,
                    }
                },

                {
                    parent: '#left-sidebar-nav',
                    target: '#indicacao-cliente',
                    content: 'Para ver os Leads que foram indicados e alocar um consultor para atender, basta no menu Cliente clicar em <b>Indicações</b>!',
                    params: {
                        cargos: [DONO, GERENTE, ESPECIALISTA],
                        placement: 'left',
                        menu: true,
                        route: '/clientes',
                        subMenu: true,
                        subMenuTarget: "#group-cliente"
                    }
                },
                {
                    parent: '',
                    target: '',
                    content: '',
                    params: {
                        cargos: [DONO, GERENTE, ESPECIALISTA],
                        placement: 'left',
                        menu: false,
                        // route: '/gerenciamento-leads'
                    }
                },
            ],
        }),

        async created() {
            this.steps = TourHelper.createSteps(this.steps);
            this.usuarioLogadoCargo = Auth.getCargoUsuario();
            this.cargoDono = DONO;
            this.cargoGerente = GERENTE;
            this.cargoCorretor = CORRETOR;
            this.cargoEspecialista = ESPECIALISTA;

            let self = this;

            await get('produto').then(function (response) {
                self.produtosItens = response.data.result.data;
            });

            this.simuladorStatus = await Auth.statusSimulador();

            if (this.simuladorStatus == 2) {
                self.produtos.push(0)
            }
        },
        methods: {
            async validateBeforeSubmit(e) {

                await Auth.loadInfo();

                const self = this;

                await this.$validator.validateAll();

                if (this.errors.any()) {
                    const message = this.errors.all()[0]
                    console.log(message)
                    Message.messageError(message);
                    return;

                }

                // else if (self.endereco.endereco_logradouro != '' && self.endereco.endereco_numero == '') {
                //     return Message.messageError('Número do endereço é obrigatório.');
                // } else if (self.enderecoComercial.endereco_logradouro != '' && self.enderecoComercial.endereco_numero == '') {
                //     return Message.messageError('Número do endereço comercial é obrigatório.');
                // }

                this.save()

            },
            save() {
                let obrigatoriaSelecionada = false;
                for (const produto of this.produtosItens) {
                    if(produto.produto_obrigatorio && this.produtos.includes(produto.produto_id)) {
                        obrigatoriaSelecionada = true;
                        break;
                    }
                }

                if (!obrigatoriaSelecionada) {
                    const resposta = confirm(`Se você prosseguir sem os fornecedores MAG, Omint, Sul América, Icatu, Porto e Itaú não terá acesso ao Cubix.
                    \nTem certeza que deseja seguir dessa forma?`);
                    if (!resposta) return;
                }

                let dataNascimento = null;
                if (this.pessoa.pessoa_data_nascimento !== '') {
                    dataNascimento = moment(this.pessoa.pessoa_data_nascimento, 'DD/MM/YYYY').format('YYYY-MM-DD')
                }

                let dataNascimentoBeneficiario = null;
                if (this.beneficiario.beneficiario_data_nascimento !== '') {
                    dataNascimentoBeneficiario = moment(this.beneficiario.beneficiario_data_nascimento, 'DD/MM/YYYY').format('YYYY-MM-DD')
                }

                let postData = {
                    pessoa_nome: this.pessoa.pessoa_nome,
                    pessoa_cpf: this.removerCaracteres(this.pessoa.pessoa_cpf),
                    pessoa_email: this.pessoa.pessoa_email,
                    pessoa_sexo: this.pessoa.pessoa_sexo,
                    pessoa_telefone: this.removerCaracteres(this.pessoa.pessoa_telefone),
                    pessoa_celular: this.removerCaracteres(this.pessoa.pessoa_celular),
                    pessoa_data_nascimento: dataNascimento,
                    pessoa_profissao: this.pessoa.pessoa_profissao,
                    pessoa_estado_civil: this.pessoa.pessoa_estado_civil,
                    pessoa_filhos: this.pessoa.pessoa_filhos,
                    pessoa_observacao: this.pessoa.pessoa_observacao,
                    beneficiario_nome: this.beneficiario.beneficiario_nome,
                    beneficiario_data_nascimento: dataNascimentoBeneficiario,
                    endereco_cep: this.removerCaracteres(this.endereco.endereco_cep),
                    endereco_estado: this.endereco.endereco_estado,
                    endereco_cidade: this.endereco.endereco_cidade,
                    endereco_bairro: this.endereco.endereco_bairro,
                    endereco_logradouro: this.endereco.endereco_logradouro,
                    endereco_numero: this.removerCaracteres(this.endereco.endereco_numero),
                    endereco_complemento: this.endereco.endereco_complemento,
                    endereco_comercial_cep: this.removerCaracteres(this.enderecoComercial.endereco_cep),
                    endereco_comercial_estado: this.enderecoComercial.endereco_estado,
                    endereco_comercial_cidade: this.enderecoComercial.endereco_cidade,
                    endereco_comercial_bairro: this.enderecoComercial.endereco_bairro,
                    endereco_comercial_logradouro: this.enderecoComercial.endereco_logradouro,
                    endereco_comercial_numero: this.removerCaracteres(this.enderecoComercial.endereco_numero),
                    endereco_comercial_complemento: this.enderecoComercial.endereco_complemento,
                };
                post('cliente', postData).then(response => {

                    // let obs = 'Marca: ' + this.auto.marca + '<br>Modelo: ' + this.auto.modelo + '<br>Ano Fabricação:' + this.auto.ano_fabricacao + ' | Ano Modelo: ' + this.auto.ano_modelo + '<br>Renovação: ' + this.auto.auto_renovacao;

                    let dados = {
                        cliente_id: response.data.result.data.cliente_id,
                        empresa_indicada_id: this.empresa_id,
                        produtos: this.produtos,
                        plataforma_origem: this.pedido.plataforma_origem,
                        pedido_estagio_id: this.pedido.pedido_estagio_id,
                    };

                    if (dados.produtos.length === 0) {
                        dados.produtos = [PRODUTO_NENHUM_ID]; // Nenhum
                    }

                    if (this.checkSeguroAuto()) {
                        Object.assign(dados, this.auto);
                    }

                    post('processo/indicacao', dados).then(response => {
                        this.produtos = [];
                        this.auto = {
                            auto_marca: '',
                            auto_modelo: '',
                            auto_ano_fab: '',
                            auto_ano_mod: '',
                        };

                        //this.resetForm();

                        //location.reload();

                        this.$router.push({
                            name: this.simuladorStatus == 2 ? 'Dashboard' : 'gerenciamentoLeads'
                        });

                        Message.messageSuccess('Cliente salvo com sucesso.');
                    });
                }).catch(function () {
                    Message.messageError('Erro ao salvar o cliente.');
                });
            },
            handleDataPessoa: function (e) {
                [
                    this.pessoa.pessoa_nome,
                    this.pessoa.pessoa_cpf,
                    this.pessoa.pessoa_email,
                    this.pessoa.pessoa_sexo,
                    this.pessoa.pessoa_telefone,
                    this.pessoa.pessoa_celular,
                    this.pessoa.pessoa_data_nascimento,
                    this.pessoa.pessoa_profissao,
                    this.pessoa.pessoa_estado_civil,
                    this.pessoa.pessoa_filhos,
                    this.pessoa.pessoa_observacao,
                ] = e;
            },
            handleDataBeneficiario: function (e) {
                [
                    this.beneficiario.beneficiario_nome,
                    this.beneficiario.beneficiario_data_nascimento,
                ] = e;
            },
            handleDataEndereco: function (e) {
                [
                    this.endereco.endereco_cep,
                    this.endereco.endereco_estado,
                    this.endereco.endereco_cidade,
                    this.endereco.endereco_bairro,
                    this.endereco.endereco_logradouro,
                    this.endereco.endereco_numero,
                    this.endereco.endereco_complemento,
                ] = e;
            },
            handleDataEnderecoComercial(e) {
                [
                    this.enderecoComercial.endereco_cep,
                    this.enderecoComercial.endereco_estado,
                    this.enderecoComercial.endereco_cidade,
                    this.enderecoComercial.endereco_bairro,
                    this.enderecoComercial.endereco_logradouro,
                    this.enderecoComercial.endereco_numero,
                    this.enderecoComercial.endereco_complemento,
                ] = e;
            },
            handleDataPedido: function (e) {
                [
                    this.pedido.plataforma_origem,
                    this.pedido.pedido_estagio_id,
                ] = e;
            },
            removerCaracteres(string) {
                let stringReplace;
                stringReplace = string.split('(').join('');
                stringReplace = stringReplace.split(')').join('');
                stringReplace = stringReplace.split('-').join('');
                stringReplace = stringReplace.split('.').join('');
                stringReplace = stringReplace.split('_').join('');
                return stringReplace;
            },
            checkProduto(id) {
                return this.produtos.indexOf(id) === -1;
            },
            marcarProduto(id) {
                if (this.produtos.indexOf(id) !== -1) {
                    this.produtos.splice(this.produtos.indexOf(id), 1);
                } else {
                    this.produtos.push(id);
                }
            },
            checkCor(id) {
                if (this.produtos.indexOf(id) !== -1) {
                    return 'blue';
                } else {
                    return 'red';
                }
            },
            abreModalDetalhe(produto) {
                this.currentProduto = produto;
                // console.log(this.currentProduto);
                setTimeout(function () {
                    $('#modalDetalheProdutos').modal();
                    $('#modalDetalheProdutos').modal('open');
                }, 500);
            },
            checkSeguroAuto() {
                const seguro_auto = this.produtosItens.find(produto => produto.produto_nome.toLowerCase() == 'seguro auto');

                return seguro_auto && this.produtos.includes(seguro_auto.produto_id);
            },
            checkValue(value) {
                if (value !== '') {
                    return 'active';
                }
                return '';
            },
            checaCargoUsuario(arrayPode) {
                if (this.usuarioLogadoCargo === MASTER) {
                    return true;
                }
                return arrayPode.indexOf(this.usuarioLogadoCargo) !== -1;
            },
            resetForm() {
                this.pessoa = {
                    pessoa_nome: '',
                    pessoa_cpf: '',
                    pessoa_email: '',
                    pessoa_sexo: '',
                    pessoa_telefone: '',
                    pessoa_celular: '',
                    pessoa_data_nascimento: '',
                    pessoa_profissao: '',
                    pessoa_estado_civil: '',
                    pessoa_filhos: '',
                    pessoa_observacao: ''
                };
                this.beneficiario = {
                    beneficiario_nome: '',
                    beneficiario_data_nascimento: '',
                };
                this.endereco = {
                    endereco_cep: '',
                    endereco_estado: '',
                    endereco_cidade: '',
                    endereco_bairro: '',
                    endereco_logradouro: '',
                    endereco_numero: '',
                    endereco_complemento: '',
                };
                this.enderecoComercial = {
                    endereco_cep: '',
                    endereco_estado: '',
                    endereco_cidade: '',
                    endereco_bairro: '',
                    endereco_logradouro: '',
                    endereco_numero: '',
                    endereco_complemento: '',
                };
                this.pedido = {
                    plataforma_origem: 1,
                    pedido_estagio_id: '',
                };
                this.produtos = [];
            },

            async submitFile ($event) {

                const blob = $event.target.files[0];

                $event.target.value = '';

                let form = new FormData()

                form.append('arquivo', blob, blob.name);

                const onUploadProgress = (progressEvent) => {

                    let progress = parseInt( Math.round( ( progressEvent.loaded / progressEvent.total ) * 100 ))

                    this.$set(this.status_upload_xml, 'progress', progress);
                };

                this.status_upload_xml = {
                    display: true,
                    icon: 'autorenew',
                    color: 'blue',
                    text: 'importando: '
                }

                await api.post('cliente/importar-xml', form, {onUploadProgress})

                .then(({data: {result: {data: {pedido}}}}) => {

                    this.status_upload_xml = {
                        display: true,
                        icon: 'check',
                        color: 'green',
                        text: 'importado com sucesso'
                    }

                    this.$router.push({
                        name: this.simuladorStatus == 2 ? 'gerenciamentoLeadSimulador' : 'gerenciamentoLead',
                        params: {pedidoId: pedido.pedido_id}
                    });

                    Message.messageSuccess('XML importado com sucesso!');

                }).catch((err) => {

                    this.status_upload_xml = {
                        display: true,
                        icon: 'error',
                        color: 'red',
                        text: 'Erro, tente novamente'
                    };
                })

                .finally(() => {
                    this.status_upload_xml = {progress: null, display: false}
                })

            },

        }
    }
</script>
<style scoped lang="scss">
.center, .center-align {
  text-align: center;
}

.container-xml {
    display: flex !important;
    justify-content: flex-end !important;
    align-items: center !important;
}

.container-xml .status {
    display: flex;
    margin: 15px;
    color: green;
}

.label_xml {
    width: 350px;
    border: 1px solid var(--color-primary);
    height: 38px;
    border-radius: 6px;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.label_xml div {
    margin: 15px;
    font-size: 12px;
}

.upload {
    color: #fff;
}

.file {
    display: none;
}

.label-disable {
    border: 1px solid #d1d1d1 !important;
}

.disable {
    background: #d1d1d1 !important;
    pointer-events: none !important;
}
</style>

<style lang="scss">
    #cliente-cadastro .card-icon {
        font-size: 40px;
    }

    #cliente-cadastro .card h6 {
        font-size: 12px;
    }

    #cliente-cadastro .scroll {
        overflow-x: hidden;
        overflow-y: scroll;
        height: 813px;
        white-space: nowrap;
    }

    .icon-absolute {
        position: absolute;
        right: 10px;
        top: 5px
    }


    .gradient-45deg-green-light-blue.gradient-shadow {
        box-shadow: 0 6px 20px 0 rgba(79, 195, 247, 0.5);
    }

    #cliente-cadastro .product .active {
        color: #fff !important;
    }

</style>



// WEBPACK FOOTER //
// src/components/clientes/Cadastro.vue